module.exports = __webpack_public_path__ + "img/icon_sy_wrz@2x.c17dfd20.png";